import { render } from "./Templates.vue?vue&type=template&id=6a309236&scoped=true"
import script from "./Templates.vue?vue&type=script&lang=js"
export * from "./Templates.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-6a309236"

export default script